import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.supplierDebtReport;
export const supplierDebtReportRoute = {
    path: rootPath,
    lazy: async () => {
        const { SupplierDebtReportContainer } = await import('@/admin/modules/reports/suppliers');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(SupplierDebtReportContainer, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
